// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__35sQ_","label":"Labeled_label__3p-ze","divider":"Labeled_divider__1ehnW"};